import service from '@/store/services/settings/districts-service';

const state = {
    list: {},
    district: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, district) => {
        state.district = district;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(district => {
                commit('SET_RESOURCE', district);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(district => {
                commit('SET_RESOURCE', district);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((district) => {
                commit('SET_RESOURCE', district);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((district) => {
                commit('SET_RESOURCE', district);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    wards ({ commit, dispatch }, params) {
        return service.wards(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    district: state => state.district,
    dropdown: (state) => {
        return state.list.map(district => ({
            id: district.id,
        }));
    }
};

const districts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default districts;
